import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideRoadmapProps {
  onContinue: () => void;
}
export function SlideRoadmap({
  onContinue
}: SlideRoadmapProps) {
  const [stage, setStage] = useState(-1);
  const steps = [{
    q: 'Stage 1',
    title: 'Pilot Phase',
    desc: '2 Brands × 3-5 Markets. Establish baseline and prove engagement model.',
    value: '€7–11K'
  }, {
    q: 'Stage 2',
    title: 'Scale & Optimize',
    desc: 'Expand to 10+ brands. Integrate behavioral data into core CRM.',
    value: '€25–50K'
  }, {
    q: 'Stage 3',
    title: 'Full Rollout',
    desc: 'Standardized operating model for all legacy brands globally.',
    value: '€400K–2M'
  }];
  useEffect(() => {
    const timers = steps.map((_, idx) => setTimeout(() => setStage(idx), 500 + idx * 600));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-12 py-16 md:px-24 md:py-20 max-w-7xl mx-auto" data-id="element-192">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-20 text-center" data-id="element-193">
        Execution Roadmap
      </motion.h2>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full relative" data-id="element-194">
        {/* Horizontal Line */}
        <div className="absolute top-12 left-0 right-0 h-1 bg-navy-600 z-0 hidden md:block" data-id="element-195" />
        <motion.div className="absolute top-12 left-0 h-1 bg-teal-400 z-0 hidden md:block" initial={{
        width: '0%'
      }} animate={{
        width: stage >= 2 ? '100%' : stage >= 1 ? '50%' : stage >= 0 ? '10%' : '0%'
      }} transition={{
        duration: 0.8,
        ease: 'easeInOut'
      }} data-id="element-196" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-197">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: stage >= idx ? 1 : 0,
          y: stage >= idx ? 0 : 30
        }} className="flex flex-col items-center text-center md:items-start md:text-left" data-id="element-198">
              <div className={`w-24 h-24 rounded-full flex items-center justify-center text-2xl font-serif font-bold mb-8 border-4 shadow-xl transition-colors duration-500 ${stage >= idx ? 'bg-teal-400 border-teal-300 text-navy-900' : 'bg-navy-800 border-navy-600 text-white/50'}`} data-id="element-199">
                {step.q}
              </div>
              <h3 className="text-2xl font-semibold text-white mb-2" data-id="element-200">
                {step.title}
              </h3>
              <p className="text-white/60 leading-relaxed mb-4" data-id="element-201">{step.desc}</p>
              <div className="mt-auto bg-teal-400/10 border border-teal-400/20 rounded-lg px-4 py-2" data-id="element-202">
                <span className="text-teal-400 font-bold text-lg" data-id="element-203">
                  {step.value}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 2 ? 1 : 0
    }} className="mt-12 flex justify-end" data-id="element-204">
        <Button onClick={onContinue} data-id="element-205">Next Steps</Button>
      </motion.div>
    </div>;
}